import { bindServices } from '@/services/api';
import { toImportExcel } from '@/services/global';
import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { queryEditActive } from './service';

const api = bindServices('apiConnectionGroup');

export const initialPagination = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const initialState = {
  isOpenModal: false,
  selectedItem: null,
  pagination: initialPagination,
  view: false,
  orderBy: '',
  apiConnectionGroupList: [],
  latestFetchApiConnectionGroupList: null,
  showImport: false,
};

const Model = {
  namespace: 'apiConnectionGroup',

  state: initialState,

  effects: {
    *fetchData({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'webApiConnectionGroup/paged',
          params: payload,
        });

        yield put({
          type: 'queryAllApiConnectionGroup',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
          },
        });

        yield put({
          type: 'saveLatestFecthApiConnectionGroup',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },
    *addNewApiConnectionGroup({ payload }, { put }) {
      yield put({
        type: 'openFormAddApiConnectionGroup',
        payload,
      });

      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewApiConnectionGroup',
          payload,
        });
      }
    },
    *saveEditApiConnectionGroup({ payload }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'webApiConnectionGroup',
          data: payload.data,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({ type: 'saveApiConnectionGroup', payload: response });

        yield put({
          type: 'repeatLatestFetchApiConnectionGroup',
        });
      } catch (error) {
        yield put({
          type: 'global/showNotificationsform',
          payload: {
            visible: true,
            type: 'error',
            message: error.message,
          },
          validationErrors: error.validationErrors,
        });
      }
    },
    *saveNewApiConnectionGroup({ payload }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'webApiConnectionGroup',
          data: payload.data,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveApiConnectionGroup',
          payload: response,
        });

        yield put({
          type: 'repeatLatestFetchApiConnectionGroup',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsform',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ id, view }, { call, put }) {
      try {
        yield put({
          type: 'global/modalConfirm',
          state: false,
          id: null,
        });

        const response = yield call(api.apiRoute, {
          route: `webApiConnectionGroup/${id}`,
          method: 'delete',
        });

        yield put({
          type: 'deleteApiConnectionGroup',
          payload: response,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'repeatLatestFetchApiConnectionGroup',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },
    *repeatLatestFetchApiConnectionGroup(__, { put, select }) {
      const latestPayload = yield select(
        (state) => state.apiConnectionGroup.latestFetchApiConnectionGroupList,
      );

      yield put({ type: 'fetchData', payload: latestPayload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *fetchImport({ payload }, { call, put }) {
      try {
        const { file, isDeleteData } = payload;
        const res = yield call(toImportExcel, {
          route: 'webApiConnectionGroup',
          fileContent: file,
          deleteExistingData: isDeleteData,
        });

        yield put({
          type: 'queryImport',
          payload: { ...res },
        });

        yield put({
          type: 'fetchData',
          payload: {
            page: 1,
            limit: 5,
          },
        });
      } catch (e) {}
    },
    *toggleImportComponent({ payload }, { put }) {
      yield put({
        type: 'queryToggleImportComponent',
        payload: { showImport: payload.show },
      });
    },
    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (e) {
        /*  */
      }
    },
  },

  reducers: {
    queryAllApiConnectionGroup(state, { payload }) {
      return {
        ...state,
        apiConnectionGroupList: payload.items.map((item) => ({
          ...item,
          isActive: item.isActive ?? false,
        })),
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
    openFormAddApiConnectionGroup(state, { payload }) {
      return {
        ...state,
        isOpenModal: payload.isOpenModal,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    saveApiConnectionGroup(state, { payload }) {
      return {
        ...state,
        saveApiConnectionGroup: payload,
        isOpenModal: false,
        selectedItem: null,
        id: null,
        orderBy: '',
      };
    },
    deleteApiConnectionGroup(state) {
      return { ...state };
    },
    selectItem(state, { payload }) {
      const item = state.apiConnectionGroupList.find(
        (apiConnection) => apiConnection.id === payload.id,
      );

      return {
        ...state,
        selectedItem: item,
        view: payload.view,
        id: payload.id,
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    resetState() {
      return initialState;
    },
    saveLatestFecthApiConnectionGroup(state, { payload }) {
      return {
        ...state,
        latestFetchApiConnectionGroupList: payload,
      };
    },

    queryImport(state) {
      return {
        ...state,
        showImport: false,
      };
    },

    queryToggleImportComponent(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    editActives(state, { payload }) {
      const apiConnectionGroupList = state.apiConnectionGroupList.map((item) =>
        item.id === payload.id ? payload : item,
      );
      return {
        ...state,
        apiConnectionGroupList,
      };
    },
  },
};

export default Model;
